// extracted by mini-css-extract-plugin
export default {"container":"DeleteUser_container__fR4iS","boxModal":"DeleteUser_boxModal__clKdF","boxBtn":"DeleteUser_boxBtn__+VXny"};